import axios from "axios";
import {
  CheckUserIdRequest,
  CheckUserIdResponse,
  LoginRequest,
  LoginResponse, PasswordReissueRequest,
  PasswordResettingRequest, RefreshTokenResponse, SignUpRequest,
  SignUpResponse,
  ValidateUserResponse,
  ValidatePasswordResponse,
} from "./dto/Login";

export const checkUserId = async (
  req: CheckUserIdRequest
): Promise<CheckUserIdResponse> => {
  const res = await axios.post<CheckUserIdResponse>("/api/users/check", req);
  return res.data;
};

export const signUp = async (req: SignUpRequest): Promise<SignUpResponse> => {
  const res = await axios.post<SignUpResponse>("/api/users/register", req);
  return res.data;
};

export const validate = async (id: string): Promise<ValidateUserResponse> => {
  const res = await axios.get<ValidateUserResponse>(`/api/user/validate?id=${id}`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};

/**
 * アクセストークン検証
 * @param accessToken アクセストークン
 * @returns
 */
export const verifyAccessToken = async (
  accessToken: string,
): Promise<boolean> => {
  const res = await axios.post(`/api/auth/verify?access_token=${accessToken}`);
  return res.status === 200;
}

/**
 * アクセストークン更新
 * @param refreshToken リフレッシュトークン
 * @returns
 */
export const refreshAccessToken = async (
  refreshToken: string,
): Promise<RefreshTokenResponse & { accessToken: string }> => {
  const res = await axios.post<RefreshTokenResponse>(`/api/auth/refresh?refresh_token=${refreshToken}`);
  return { ...res.data, accessToken: res.headers.authorization };
}

/**
 * ログインAPIを呼び出す
 * @param req
 * @returns JWTトークンとJWTリフレッシュトークンを含むユーザー情報
 */
export const login = async (
  req: LoginRequest
): Promise<LoginResponse & { accessToken: string }> => {
  const res = await axios.post<LoginResponse>("/api/login", req);
  return { ...res.data, accessToken: res.headers.authorization };
};

/**
 * 新規会員登録時用ログインAPIを呼び出す
 * @param req
 * @returns JWTトークンとJWTリフレッシュトークンを含むユーザー情報
 */
export const loginRegisterUsers = async (
  id: string
): Promise<LoginResponse & { accessToken: string }> => {
  const res = await axios.post<LoginResponse>(`/api/users/register/login?id=${id}`,{
    headers: { "Content-Type": "application/json;charset=utf-8" }})
  return { ...res.data, accessToken: res.headers.authorization };
};

export const passwordReissue = async (req: PasswordReissueRequest): Promise<void> => {
  const res = await axios.post<void>("/api/user/password", req);
  return res.data;
};

export const passwordResetting = async (req: PasswordResettingRequest): Promise<void> => {
  const res = await axios.post<void>("/api/user/password/resetting", req)
  return res.data
}

export const validatePasswordResetting = async (id: string): Promise<ValidatePasswordResponse> => {
  const res = await axios.get<ValidateUserResponse>(`/api/user/password/validate?id=${id}`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};